import { IViewData } from "./ViewRestaurant";
import { IOfferListItem } from "../../interfaces/IOffer";
import { TStorage } from "../../../avernus/tstorage/TStorage";

export interface IOfferWithPiece extends IOfferListItem{
    piece:number
}

export type IPaymentType = 'bank_transfer'|'apple_pay'|'pay_with_card_or_paypal'|'starbucks';
export type IDeliveryType = 'personal_pick_up'|'delivery';

export class Order{

    static restaurant   : IViewData;
    static offers       : Array<IOfferWithPiece>
    static paymentMethod: IPaymentType
    static deliveryType : IDeliveryType

    constructor() {
        Order.init();
    }

    private static init():void{
        let Storage         = new TStorage();
        Order.restaurant    = Storage.get('Order_restaurant', null);
        Order.offers        = Storage.get('Order_offers', []);
        Order.paymentMethod = Storage.get('Order_paymentMethod', null);
        Order.deliveryType  = Storage.get('Order_deliveryType', 'personal_pick_up');
    }

    public static cleanStorage():void{
        let Storage = new TStorage();
        Storage.set('Order_restaurant', null);
        Storage.set('Order_offers', []);
        Storage.set('Order_paymentMethod', null);
        Order.init();
    }

    public static setRestaurant(restaurant:IViewData):void{
        let Storage       = new TStorage();
        Storage.set('Order_restaurant', restaurant);
        this.restaurant = restaurant;
    }

    public static setEmptyRestaurant():void{
        let Storage       = new TStorage();
        Storage.set('Order_restaurant', null);
        this.restaurant = null;
    }

    public static getRestaurant():IViewData{
        return this.restaurant;
    }

    public static setOffer(offer:IOfferWithPiece):void{
        let Storage         = new TStorage();
        let offers          = [];
        /*
        disabled more offers order
        let offers          = this.offers;
        let updated:boolean = false;
        for (var key in offers) {
            var item = offers[key];
            if ( item.id == offer.id ) {
                item = offer;
                updated = true;
                break;
            }
        }
        */
        // if (  updated === false ) {
            offers.push(offer);
        // }

        Storage.set('Order_offers', offers);
        this.offers = offers;
    }

    public static setEmptyOffer():void{
        let Storage         = new TStorage();
        let offers          = null;
        Storage.set('Order_offers', offers);
        this.offers = offers;
    }

    public static getOffers():Array<IOfferWithPiece>{
        console.log('offers',this.offers);
        return this.offers===null?null:this.offers;
    }

    public static getOffer():IOfferWithPiece{
        if (  this.offers[0] !== undefined ) {
            return this.offers[0];
        }
        return null;
    }

    public static getRestaurantId():number{
        let restaurant = this.getRestaurant();
        if (  restaurant !== null ) {
            return restaurant.id;
        }

        return undefined;
    }

    public static getOfferId():number{
        let offer = this.getOffer();
        if (  offer !== null ) {
            return offer.id;
        }

        return undefined;
    }

    public static setDelivery(deliveryType:IDeliveryType){
        let Storage         = new TStorage();
        Storage.set('Order_deliveryType', deliveryType);
        this.deliveryType   = deliveryType;
    }

    public static getDelivery():IDeliveryType{
        return this.deliveryType;
    }


    public static setPaymentMethod(paymentMethod:IPaymentType){
        let Storage         = new TStorage();
        Storage.set('Order_paymentMethod', paymentMethod);
        this.paymentMethod = paymentMethod;
    }

    public static getPaymentMethod():IPaymentType{
        return this.paymentMethod;
    }

}
new Order();
